import React, { useState, useEffect, useRef } from 'react'
import extraImg from '../assets/empty-cart.gif';
import ResponseMsg from '../general/ResponseMsg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import '../css/components/OrderHistory.css'
import Loading from '../general/Loading';
import Logo from '../assets/logo.png';
import Default from '../assets/default.jpg';


const ManageOrders = ({ userData }) => {
    const today = new Date();
  const priorDate = new Date();
  priorDate.setDate(today.getDate() - 3);

  const formatInputDate = (date) => {
    // YYYY-MM-DD format for input type="date"
    return date.toISOString().split('T')[0];
  };

  const [orders, setOrders] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedOrder, setSelectedOrder] = useState();
  const [showUpdate, setShowUpdate] = useState(false);
  const [newStatus, setNewStatus] = useState('');
  const [newTime, setNewTime] = useState('');
  const [response, setResponse] = useState('');
  const [showInvoice, setShowInvoice] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedOrderPay, setSelectedOrderPay] = useState();
  const [showTime, setShowTime] = useState();
 const [fromDate, setFromDate] = useState(formatInputDate(priorDate));
  const [toDate, setToDate] = useState(formatInputDate(today));

  
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editedItems, setEditedItems] = useState([]);

  const handleFromIconClick = () => {
    fromDateRef.current?.showPicker();
  };
  
  const handleToIconClick = () => {
    toDateRef.current?.showPicker();
  };


  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);

      try {
        const response = await fetch(`https://api.kcmstore.in/dist/get-orders`);
        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          setOrders(sortedProducts);
        } else {
          setLoading(false);
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };

    fetchOrders();
  }, []);


  const fetchPaymentDetails = async (orderId) => {
    try {
      const response = await fetch(`https://api.kcmstore.in/dist/get-payment/${orderId}`);
      if (response.ok) {
        const data = await response.json();
        setSelectedOrderPay(data);
      } else {
        setSelectedOrderPay();
        console.error('Failed to fetch payment details');
      }
    } catch (error) {
      setSelectedOrderPay();
      console.error('Error fetching payment details:', error);
    }
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


const filteredOrders = orders.filter(order => {
  const orderDate = new Date(order.order_date);
  const from = fromDate ? new Date(fromDate) : null;
  const to = toDate ? new Date(toDate) : null;

  // Normalize the dates to midnight
  orderDate.setHours(0, 0, 0, 0);
  if (from) from.setHours(0, 0, 0, 0);
  if (to) to.setHours(0, 0, 0, 0);

  const isInDateRange = (!from || orderDate >= from) && (!to || orderDate <= to);

  const isUserMatch = order.user_name.toLowerCase().includes(searchQuery.toLowerCase());
  const isIdMatch = order.id && order.id.toString().toLowerCase().includes(searchQuery.toLowerCase());

  return isInDateRange && (isUserMatch || isIdMatch);
});


  const handleUpdateDialog = (order) => {
    setSelectedOrder(order);
    setShowUpdate(true);
  }

  const handleTimeDialog = (order) => {
    setSelectedOrder(order);
    setShowTime(true);
  }

  const invoiceDialog = (order) => {
    setSelectedOrder(order);
    // console.log(order);
    setShowInvoice(true);
    fetchPaymentDetails(order.id);
  }

  const handlePrint = () => {
    window.print();
  }

  const handleUpdateStatus = async (orderId, status) => {
    try {
      const response = await fetch(`https://api.kcmstore.in/dist/update-order-status/${orderId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          status: status,
          payment_mode: selectedOrder.payment_mode,
          due_amount: selectedOrder.total_amount,
        }),
      });

      if (response.ok) {
        const updatedOrder = await response.json();
        setOrders(prevOrders =>
          prevOrders.map(order =>
            order.id === orderId ? { ...order, order_status: status } : order
          )
        );
        setShowUpdate(false);
        setResponse('Order status updated successfully');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      } else {
        setResponse('Failed to update order status');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      }
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };


  const handleUpdateTime = async (orderId, time) => {
    try {
      const response = await fetch(`https://api.kcmstore.in/dist/update-order-time/${orderId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          delivery_time: time,
        }),
      });

      if (response.ok) {
        const updatedOrder = await response.json();
        setOrders(prevOrders =>
          prevOrders.map(order =>
            order.id === orderId ? { ...order, delivery_time: time } : order
          )
        );
        setShowTime(false);
        setResponse('Order Delivery Time updated');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      } else {
        setResponse('Failed to update order delivery time');
        setTimeout(() => {
          setResponse('');
        }, 2000)
      }
    } catch (error) {
      console.error('Error updating order time:', error);
    }
  };

  const recalculateGrandTotal = () => {
    const newTotal = editedItems.reduce((acc, item) => {
      const itemTotal = parseFloat(item.product_sp || 0) * parseFloat(item.quantity || 0);
      return acc + itemTotal;
    }, 0);
  
    return newTotal.toFixed(2); // Return as a fixed decimal string
  };
  

  const handleEditOrder = (order) => {
    setSelectedOrder(order);
    try {
      const parsedItems = JSON.parse(order.order_items);
      // Ensure discount fields exist
      const updatedItems = parsedItems.map((item) => ({
        ...item,
        product_discount_amount: item.product_discount_amount ?? 0,
        product_discount_type: item.product_discount_type ?? 'amount',
        free: item.free ?? 0,
      }));
      setEditedItems(updatedItems);
    } catch (e) {
      console.error("Error parsing order items", e);
      setEditedItems([]);
    }
    setEditDialogOpen(true);
  };
      

  return (
    <>
      <section className='px-3 py-3'>
        <div className='profile-area-inner px-lg-5 py-lg-5 px-3 py-3 animate__animated animate__fadeInUp'>
          <p className='profile-heading'>Manage Orders</p>

          <div className='d-flex bg-light rounded-4 py-2'>
            <i class="fa-solid fa-magnifying-glass text-darkblue py-2 px-3"></i>
            <input
              type="text"
              className="form-input rounded-4 border-0 bg-light w-100"
              placeholder="Search by Order Id, Retailer Name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>


          <div className="d-flex justify-content-between my-3">
  {/* From Date */}
  <div className="position-relative d-flex align-items-center">
    <label className="form-label fw-semibold me-2 my-2">From Date</label>

    {/* Hidden but positioned input */}
    <input
      type="date"
      ref={fromDateRef}
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      className="position-absolute"
      style={{
        opacity: 0,
        width: '38px', // Same size as button
        height: '38px',
        cursor: 'pointer',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
      }}
    />

    <button className="btn border px-3 py-2 position-relative" onClick={handleFromIconClick}>
      <i className="fa-solid fa-calendar-days"></i>
    </button>
  </div>

  {/* To Date */}
  <div className="position-relative d-flex align-items-center">
    <label className="form-label fw-semibold me-2 my-2">To Date</label>

    <input
      type="date"
      ref={toDateRef}
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      className="position-absolute"
      style={{
        opacity: 0,
        width: '38px',
        height: '38px',
        cursor: 'pointer',
        left: 0,
        top: '50%',
        transform: 'translate(-200%, -50%)',
      }}
    />

    <button className="btn border px-3 py-2 position-relative" onClick={handleToIconClick}>
      <i className="fa-solid fa-calendar-days"></i>
    </button>
  </div>
</div>

{(fromDate && toDate) && (
  <p className="fw-semibold text-muted">
    Showing orders from {formatDate(fromDate || '...')} to {formatDate(toDate || '...')}
  </p>
)}
          <hr />

 
          {filteredOrders.length > 0 ? (
            filteredOrders.map((order) => {
              const orderItems = JSON.parse(order.order_items);
              return (
                <div className='my-3' key={order.id}>
                  <div className='order-area'>

                    <div className='d-flex justify-content-between'>
                    <p className='fw-semibold para-text my-0'># Order ID-{order.id}<br />Placed on {formatDateTime(order.order_date)} By {order.user_name}</p>

                    {order.order_status == 'Placed' ?
                    <p className='fw-semibold para-text my-0 py-0 cursor-pointer' onClick={() => handleEditOrder(order)}>✏ Edit Order</p>
                    : '' }
                    </div>
                    {/* <p className='text-muted fw-semibold para-text'>Party Name: {order.user_name}<br />
                                            Address: {order.user_address} {order.user_city} {order.user_state}`
                                        </p> */}
                    <Swiper spaceBetween={20} slidesPerView={7} modules={[Navigation]} loop={true}
                      navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                      breakpoints={{
                        0: {
                          slidesPerView: 3,
                        },
                        768: {
                          slidesPerView: 4,
                        },
                        992: {
                          slidesPerView: 6,
                          1200: {
                            slidesPerView: 7,
                          }
                        }
                      }}>
                      {orderItems.length > 0 ? (
                        orderItems.map((item, index) => (
                          <>
                            <SwiperSlide key={index} className='my-2'>
                              <img
                                src={item.image
                                  ? `https://api.kcmstore.in/uploads/${item.image.split(',')[0]}`
                                  : Default}
                                className='img-fluid'
                                alt='Order'
                              />
                              {/* <p className='my-0 para-text'>{item.product_name}</p> */}
                              {/* <span className='text-muted para-text'>{item.quantity} Item</span> */}

                            </SwiperSlide>
                          </>
                        ))
                      ) : (
                        <p>No items in this order</p>
                      )}
                    </Swiper>
                    <p className='text-muted para-text fw-semibold my-0'>Order Total ₹ {order.total_amount}</p>
                    <p className='text-muted para-text fw-semibold my-0'>
                      {/* {order.order_status != 'Confirmed' && `This Order has been ${order.order_status} `} */}
                      This Order has been {order.order_status}&nbsp;
                      {order.order_status === 'Delivered'
                        ? (order.delivery_time == null ? '' : `in ${order.delivery_time}.`)
                        : (order.delivery_time == null ? '' : `& will reach in ${order.delivery_time}.`)}
                      <br />
                      Remark: {order.remark || 'NA'}</p>
                      <button className='add-btn my-1' onClick={() => invoiceDialog(order)}>Order Details</button>&nbsp;&nbsp;
                    {order.order_status != 'Delivered' ? (
                      <>
                        <button className='add-btn my-1' onClick={() => handleTimeDialog(order)}>Delivery Time</button>&nbsp;&nbsp;
                        <button className='add-btn my-1' onClick={() => handleUpdateDialog(order)}>Update Status</button>
                      </>
                    ) : ''}
                    <hr />
                  </div>
                </div>
              );

            })
          ) : (
            <div className='text-center'>
              <img src={extraImg} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
              <p>No Orders Placed yet</p>
            </div>
          )}


        </div>
      </section>

      {showUpdate && (
        <>
          <section className='detail-dialog animate__animated animate__zoomIn' onClick={() => setShowUpdate(false)}>
            <div className='detail-dialog-inner col-xl-4 col-lg-5 col-md-8 col-sm-10 col-12 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>
              <p className='profile-subheading my-3'>Update Order Status</p>

              <select
                id="order-status"
                className="profile-input mb-4"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}>
                <option value="">Select status</option>
                <option value="Confirmed">Confirmed</option>
                <option value="Dispatched">Dispatched</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
              </select>

              <button className='login-btn px-3 py-1' onClick={() => handleUpdateStatus(selectedOrder.id, newStatus)}>Yes</button>&nbsp;&nbsp;
              <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowUpdate(false)}>No</button>
            </div>
          </section>
        </>
      )}


      {showTime && (
        <section className='detail-dialog animate__animated animate__zoomIn' onClick={() => setShowUpdate(false)}>
          <div className='detail-dialog-inner col-xl-4 col-lg-5 col-md-8 col-sm-10 col-12 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>
            <p className='profile-subheading my-3'>Update Delivery Time</p>

            <select
              id="order-status"
              className="profile-input mb-4"
              value={newTime}
              onChange={(e) => setNewTime(e.target.value)}>
              <option value="">Select Delivery Time</option>
              <option value="20 Minutes">20 Minutes</option>
              <option value="30 Minutes">30 Minutes</option>
              <option value="45 Minutes">45 Minutes</option>
              <option value="1 Hour">1 Hour</option>
              <option value="1 Hour 15 Minutes">1 Hour 15 Minutes</option>
              <option value="1 Hour 30 Minutes">1 Hour 30 Minutes</option>
              <option value="1 Hour 45 Minutes">1 Hour 45 Minutes</option>
              <option value="2 Hours">2 Hours</option>
            </select>

            <button className='login-btn px-3 py-1' onClick={() => handleUpdateTime(selectedOrder.id, newTime)}>Yes</button>&nbsp;&nbsp;
            <button className='login-btn px-3 py-1 bg-danger' onClick={() => setShowTime(false)}>No</button>
          </div>
        </section>
      )}

      {response && <ResponseMsg message={response} />}


      {showInvoice && selectedOrder && (
        <>
          <section className='invoice-dialog' onClick={() => setShowInvoice(false)}>
            <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>

              <p className='profile-subheading text-center'>Order Invoice</p>
              <img src={Logo} className='invoice-watermark' alt='WaterMark' />

              <div className='invoice-area'>


                <p className='fw-semibold my-0'>Sold By: {userData.name}</p>
                <p className='para-text fst-italic my-0'><span className='fw-semibold'>Billing Address:</span> {userData.address} {userData.city} {userData.state} {userData.pincode}</p>
                <p className='para-text fst-italic my-0'><span className='fw-semibold'>GSTIN: </span>{userData.gst || 'NA'}<br />
                  <span className='fw-semibold'>Drug License No: </span>{userData.drug_license || 'NA'}</p>


                <div className='text-end'>
                  <span className='invoice-num fw-semibold'>Invoice Number {selectedOrderPay?.id || 'NA'}</span></div>

                <hr />

                <div className='d-flex pt-2'>
                  <div>
                    <p className='fw-semibold my-0'>Order Id: {selectedOrder.id}</p>
                    <p><span className='fw-semibold'>Order Date: </span>{formatDateTime(selectedOrder.order_date)}</p></div>

                  <p className='ms-4'><span className='fw-semibold'>Delivery Address</span><br />
                    {selectedOrder.user_address} {selectedOrder.user_city} {selectedOrder.user_state} {selectedOrder.user_pincode}</p>

                </div>
                {/* flex ends */}

                <hr />


                <div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                      <th className='fw-semibold px-2'>Product</th>
                      <th className='fw-semibold px-2'>Qty</th>
                      <th className='fw-semibold px-2'>MRP</th>
                      <th className='fw-semibold px-2'>Discount</th>
                      <th className='fw-semibold px-2'>Tax</th>
                      <th className='fw-semibold px-2'>Sale Price</th>
                      <th className='fw-semibold px-2'>Total</th>
                    </tr>

{typeof selectedOrder.order_items === 'string' ? (
  (() => {
    try {
      const parsedItems = JSON.parse(selectedOrder.order_items);
      if (Array.isArray(parsedItems)) {
        const totalItems = parsedItems.reduce(
          (acc, item) => acc + (parseInt(item.quantity) || 0),
          0
        );

        return (
          <>
            {parsedItems.map((item, index) => (
              <tr key={index}>
                <td className='px-2 py-2 fw-semibold'>{item.product_name}</td>
                <td className='px-2 py-2 fw-semibold'>{item.quantity}</td>
                <td className='px-2 py-2 fw-semibold'>₹{item.product_org}</td>
                <td className='px-2 py-2 fw-semibold'>
                  {item.product_discount_type == 'amount' ? '₹' : ''}
                  {item.product_discount_amount || 'NA'}
                  {item.product_discount_type == 'percent' ? '%' : ''}
                </td>
                <td className='px-2 py-2 fw-semibold'>
                  {item.product_tax && item.product_tax.toLowerCase() !== 'none'
                    ? (() => {
                        const match = item.product_tax.match(/([\d.]+)/);
                        const taxValue = match ? parseFloat(match[0]) : null;
                        if (!isNaN(taxValue) && taxValue > 0) {
                          if (taxValue === 0.25 || taxValue === 0) {
                            return `GST ${taxValue}%`;
                          }
                          const halfTax = (taxValue / 2).toFixed(2);
                          return `CGST ${halfTax}% SGST ${halfTax}%`;
                        }
                        return item.product_tax;
                      })()
                    : 'none'}
                </td>
                <td className='px-2 py-2 fw-semibold'>₹{item.product_sp}</td>
                <td className='px-2 py-2 fw-semibold'>
                  ₹{(item.product_sp * item.quantity).toFixed(2)}
                </td>
              </tr>
            ))}

              <td colSpan="7">
                            <hr />
</td>
            <tr>
              <td colSpan="7" className="para-text fw-semibold">
                Total Items: {totalItems}
              </td>
            </tr>
          </>
        );
      }
    } catch (error) {
      return <p>Failed to get items.</p>;
    }
  })()
) : (
  <p>No items available.</p>
)}


                  </table>
                </div>

                {selectedOrder.payment_mode == 'Cash' ?
                  <span className='para-text'>Payment Mode: {selectedOrder.payment_mode}<br />Payment Status: {selectedOrder.payment_status}</span> :
                  <span>Payment Mode: {selectedOrder.payment_mode}<br />Payment Id: {selectedOrder.payment_id}<br />
                    Payment Status: {selectedOrder.payment_status}<br /></span>}


                <p className='para-text fw-semibold text-end'>Grand Total ₹{selectedOrder.total_amount}<br />
                <span className='text-success'>Amount Paid: ₹{selectedOrderPay?.amount_received || 'NA'}</span><br />
                <span className='text-danger'>Due Amount: ₹{selectedOrderPay?.due_amount || 'NA'}</span></p>

                <p className='para-text text-center mt-4 fw-semibold'>Thanks for choosing KCM Distributors as your Medicine Supplier.</p>


              </div>
              {/* invoice ends */}

              <button className='login-btn px-3 py-2 mt-4 bg-danger' onClick={() => setShowInvoice(false)}>Close</button>&nbsp;&nbsp;
              <button className='login-btn px-3 py-2 mt-4' onClick={handlePrint}>Download</button>


            </div>
          </section>
        </>
      )}


{editDialogOpen && selectedOrder && (
          <section className='invoice-dialog' onClick={() => setShowInvoice(false)}>
          <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-9 mx-auto px-lg-5 py-lg-5 px-3 py-3' onClick={(e) => e.stopPropagation()}>

            <p className='profile-subheading text-center'>Edit Order Details</p>
            <img src={Logo} className='invoice-watermark' alt='WaterMark' />

            <div className='invoice-area'>

              <hr />

              <div className='d-flex'>
                <div>
                  <p className='fw-semibold my-0'>Order Id: {selectedOrder.id}</p>
                  <p><span className='fw-semibold'>Order Date: </span>{formatDateTime(selectedOrder.order_date)}</p></div>

                <p className='ms-4'><span className='fw-semibold'>Delivery Address</span><br />
                  {selectedOrder.user_address} {selectedOrder.user_city} {selectedOrder.user_state} {selectedOrder.user_pincode}</p>

              </div>
              {/* flex ends */}

              <hr />


              <div className='table-responsive'>
                <table className='w-100'>
                  <tr>
                    <th className='fw-semibold px-2'>Product</th>
                    <th className='fw-semibold px-2'>Qty</th>
                    <th className='fw-semibold px-2'>MRP</th>
                    <th className='fw-semibold px-2'>Discount</th>
                    <th className='fw-semibold px-2'>Discount Type</th>
                    <th className='fw-semibold px-2'>Free Qty</th>
                    <th className='fw-semibold px-2'>Sale Price</th>
                    <th className='fw-semibold px-2'>Total</th>
                  </tr>

                  {editedItems.map((item, index) => {
  const orgPrice = parseFloat(item.product_org || 0);
  const discount = parseFloat(item.product_discount_amount || 0);
  const type = item.product_discount_type || 'amount';

  let salePrice = orgPrice;
  if (type === 'amount') salePrice = orgPrice - discount;
  if (type === 'percent') salePrice = orgPrice - (orgPrice * discount) / 100;
  const roundedSP = Math.max(salePrice, 0).toFixed(2);

  return (
    <tr key={index}>
      <td className='px-2 py-2 fw-semibold'>{item.product_name}</td>
      <td className='px-2 py-2 fw-semibold'>{item.quantity}</td>
      <td className='px-2 py-2 fw-semibold'>₹{orgPrice.toFixed(2)}</td>
      <td className='px-2 py-2'>
        <input
          type='text'
          className='profile-input form-control-sm'
          value={item.product_discount_amount}
          onChange={(e) => {
            const updatedItems = editedItems.map((itm, idx) => {
              if (idx === index) {
                const newDiscount = parseFloat(e.target.value) || 0;
                let newSP =
                  item.product_discount_type === 'percent'
                    ? orgPrice - (orgPrice * newDiscount) / 100
                    : orgPrice - newDiscount;

                return {
                  ...itm,
                  product_discount_amount: newDiscount,
                  product_sp: Math.max(newSP, 0).toFixed(2),
                };
              }
              return itm;
            });
            setEditedItems(updatedItems);

            // Recalculate and update the grand total
            const newGrandTotal = recalculateGrandTotal();
            setSelectedOrder({
              ...selectedOrder,
              total_amount: newGrandTotal,
            });
          }}
        />
      </td>

      <td className='px-2 py-2' style={{ position: 'relative', zIndex: 1000 }}>
        <select
          className='profile-input form-select-sm'
          style={{ zIndex: 1001, position: 'relative' }}
          value={item.product_discount_type}
          onChange={(e) => {
            const updatedItems = editedItems.map((itm, idx) => {
              if (idx === index) {
                const newType = e.target.value;
                const discountVal = parseFloat(itm.product_discount_amount) || 0;
                let newSP =
                  newType === 'percent'
                    ? orgPrice - (orgPrice * discountVal) / 100
                    : orgPrice - discountVal;

                return {
                  ...itm,
                  product_discount_type: newType,
                  product_sp: Math.max(newSP, 0).toFixed(2),
                };
              }
              return itm;
            });
            setEditedItems(updatedItems);

            // Recalculate and update the grand total
            const newGrandTotal = recalculateGrandTotal();
            setSelectedOrder({
              ...selectedOrder,
              total_amount: newGrandTotal,
            });
          }}
        >
          <option value='amount'>Amount</option>
          <option value='percent'>Percent</option>
        </select>
      </td>

      <td className='px-2 py-2'>
        <input
          type='text'
          className='profile-input form-control-sm'
          value={item.free}
          onChange={(e) => {
            const updatedItems = editedItems.map((itm, idx) =>
              idx === index ? { ...itm, free: e.target.value } : itm
            );
            setEditedItems(updatedItems);

            // Recalculate and update the grand total
            const newGrandTotal = recalculateGrandTotal();
            setSelectedOrder({
              ...selectedOrder,
              total_amount: newGrandTotal,
            });
          }}
        />
      </td>

      <td className='px-2 py-2 fw-semibold'>₹{item.product_sp}</td>
      <td className='px-2 py-2 fw-semibold'>₹{(item.product_sp * item.quantity).toFixed(2)}</td>
    </tr>
  );
})}


                </table>
              </div>

              <hr />

              {/* {selectedOrder.payment_mode == 'Cash' ?
                <span className='para-text'>Payment Mode: {selectedOrder.payment_mode}<br />Payment Status: {selectedOrder.payment_status}</span> :
                <span>Payment Mode: {selectedOrder.payment_mode}<br />Payment Id: {selectedOrder.payment_id}<br />
                  Payment Status: {selectedOrder.payment_status}<br /></span>} */}


              <p className='para-text fw-semibold text-end'>Grand Total ₹{selectedOrder.total_amount}
              </p>

              <p className='para-text text-center mt-4 fw-semibold'>Once the Order gets Confirmed it will not be Edited.</p>


            </div>
            {/* invoice ends */}

            <button className='login-btn px-3 py-2 mt-4 bg-danger' onClick={() => setEditDialogOpen(false)}>Close</button>&nbsp;&nbsp;
            <button
  className='login-btn px-3 py-2 mt-4'
  onClick={async () => {

    const oldItems = Array.isArray(selectedOrder.order_items)
  ? selectedOrder.order_items
  : JSON.parse(selectedOrder.order_items || '[]');

// Map only product_id and free
const old_items = oldItems.map(item => ({
  product_id: item.product_id,
  old_free: item.free,
}));


const updatedOrder = {
  ...selectedOrder,
  order_items: JSON.stringify(editedItems),
  old_items: old_items,
};

setLoading(true);

    try {
      const response = await fetch(`https://api.kcmstore.in/dist/update-purchase-order/${selectedOrder.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedOrder),
      });

      setLoading(false);
      if (!response.ok) {
        setResponse('Failed to update order');
        setTimeout(() => {
          setResponse('');
      }, 1500);
      }

      const result = await response.json();
      // console.log('Order updated:', result);
      setEditDialogOpen(false);
      setResponse('Order Updated Successfully!');
      setTimeout(() => {
          setResponse('');
          window.location.reload();
      }, 1500);


    } catch (error) {
      setLoading(false);
      console.error('Error updating order:', error);
    }
  }}
>
  Update
</button>


          </div>
        </section>
)}


      {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default ManageOrders
